import { render } from "./PersonalInfoList.vue?vue&type=template&id=ed311996&scoped=true"
const script = {}

import "./PersonalInfoList.vue?vue&type=style&index=0&id=ed311996&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed311996"]])

export default __exports__